import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { BookmarkIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createGuide } from '../../api/guides/create-guide'
import UserNavBar from '../../components/elements/nav-bar'
import GuideForm from '../../components/pages/guides/guide-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'

const GuideCreatePage = () => {
  const { navigate } = useNavigator()

  const createMutation = useMutation({
    mutationFn: createGuide,
    onSuccess: (data) => {
      navigate(Paths.GUIDE_LIST_PAGE)
      toast.success(`Guide "${data.name}" créé avec succès`)
    }
  })

  return (
    <div>
      <UserNavBar title={'Créer un guide'} icon={BookmarkIcon} />

      <div className={'h-4'} />

      <Box className="px-6 py-8">
        <GuideForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: createMutation.mutateAsync,
            onCancel: () => navigate(Paths.GUIDE_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}

export default GuideCreatePage
